import { render, staticRenderFns } from "./TableManual.vue?vue&type=template&id=19fce93c&"
import script from "./TableManual.vue?vue&type=script&lang=js&"
export * from "./TableManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports